import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UserClient } from 'src/app/Services/WOWApi.Service';
import { CommonService } from 'src/app/Services/common.service';


@Component({
    selector: 'app-email-verification',
    templateUrl: './email-verification.component.html',
    styleUrls: ['./email-verification.component.css'],
    standalone: false
})
export class EmailVerificationComponent implements OnInit {
  verificationStatus: string = 'Verifying.....';
  isSuccess: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private myAccountClient: UserClient,
    private commonService: CommonService,
    private router: Router,
  ) {}

  ngOnInit(): void {
    const value1 = this.route.snapshot.queryParamMap.get('Value1');
    const value2 = this.route.snapshot.queryParamMap.get('Value2');
    console.log(value1, value2);
    if (value1 && value2) {
      this.verifyEmail(value1, value2);
    } else {
      this.verificationStatus = 'Invalid verification link.';
    }
  }

  verifyEmail(value1: string, value2: string): void {
    this.commonService.setSpinner(true);
    this.myAccountClient.verifyEmail(value1, value2).subscribe(
      (response: any) => {
        console.log(response);
        this.isSuccess = true;
        this.verificationStatus = response.message;
        this.commonService.setSpinner(false);
      },
      (error) => {
        console.log(error);
        this.isSuccess = false;
        this.verificationStatus = 'Email verification failed. Please try again.';
        this.commonService.setSpinner(false);
      }
    );
  }

  goToLogin(): void {
    localStorage.removeItem("UserInfo"); 
    this.commonService.setUserLoggedIn(false);
    this.router.navigateByUrl('/Webinar-rooms');
    this.commonService.setIsPageReload(true);
    this.router.navigate(['/login']);
  }

}
